<template>
    <div class='col-md-6 p-2'>
      <div class='hub-services-container'>
        <div class="collapsible p-3" @click="toggleShowServices" ref="collapsible" :title="hub.name">
          <div class="hub-label  pr-4"> {{ hub.name }} </div>
        </div>
        <transition name="slide-fade">
          <div v-if="showServices">
            <table class="table table-hover-pink" role="grid">
              <thead>
                <tr>
                  <th>{{ $t('ServiceHubTable.name') }}</th>
                  <th class="actions">{{ $t('ServiceHubTable.actions') }}</th>
                </tr>
              </thead>
              <tbody>
                <service-row v-for="service in services" :service="service" :key="service.id" @reloadList="reloadList"></service-row>
              </tbody>
            </table>
          </div>
        </transition>
      </div>
    </div>
</template>

<script type="text/javascript">
  import ServiceRow from './ServiceRow'

  export default {
    name: 'ServiceHubTable',
    components: {
      ServiceRow
    },
    props: ['hub'],
    data: function() {
      return {
        showServices: false
      }
    },
    computed: {
      services() {
        return _.orderBy(this.hub.services, 'name', 'asc')
      }
    },
    methods: {
      reloadList: function(){
        this.$emit('reloadList')
      },
      toggleShowServices: function() {
        this.showServices = !this.showServices
        this.$refs.collapsible.classList.toggle('opened')
      }
    }
  }
</script>


<style lang="scss" scoped>
  .hub-label {
    font-weight: bold;
    margin-left: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .hub-services-container {
    border: 1px solid #e8e8e8;
    box-shadow: 0px 0px 10px 0 rgba(0, 0, 0, 0.1);
  }
  .collapsible:after {
    top: 12px;
    right: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/components/services/ServiceHubTable.vue